import { createElement } from '@max/max';
import View from '@hfe/max-view';
// import Image from '@hfe/max-image';
import LImage from '@max/leez-image';
import Text from '@hfe/max-text';
import './index.scss';
import { rpx2px } from '@hfe/max-universal-unit-tool';
// 角标类型枚举
var CornerMarkType;
(function (CornerMarkType) {
    CornerMarkType["HISTORY_BROWSE"] = "historyBrowse";
    CornerMarkType["ANGLE_IMG"] = "angleImg";
    CornerMarkType["POS_TAG_IMAGE"] = "posTagImage";
    CornerMarkType["POS_TAG_TEXT"] = "posTagText";
    CornerMarkType["HEAD_ICON_TEXT"] = "headIconText";
    CornerMarkType["HEAD_ICON_IMAGE"] = "headIconImage";
    CornerMarkType["NONE"] = "none";
})(CornerMarkType || (CornerMarkType = {}));
/**
 * 计算角标展示信息
 * 优先级：angleImg > posTagList > headIcon，即订单通标签＞场景标签＞运营配置静态标签
 */
const getCornerMarkInfo = (angleImg, posTagList, headIcon, headIconImg, headIconText, showCornerMark, headIconTextColor, headIconBackgroundColor, headIconBorderColor, isRecallRecommend, isHistoryBrowsed) => {
    // 0. 优先级最高：历史浏览标识
    if (isHistoryBrowsed) {
        return {
            type: CornerMarkType.HISTORY_BROWSE,
            imageUrl: 'https://img.meituan.net/makerjiulv/ed2ef1458dc35c9f1029011ce025d0a56344.png'
        };
    }
    // 1. 优先级最高:angleImg
    if (angleImg?.needTag && !isRecallRecommend) {
        return {
            type: CornerMarkType.ANGLE_IMG,
            imageUrl: angleImg.imgUrl || 'https://p0.meituan.net/ingee/0dac66a13808f95fbd642ae4fb4a374c5823.png'
        };
    }
    // 2. 优先级第二:posTagList
    if (posTagList && posTagList.length > 0) {
        const firstTag = posTagList[0];
        // 2.1 posTagList 有图片
        if (firstTag.imgUrl) {
            return {
                type: CornerMarkType.POS_TAG_IMAGE,
                imageUrl: firstTag.imgUrl
            };
        }
        // 2.2 posTagList 有文字
        if (firstTag.title) {
            return {
                type: CornerMarkType.POS_TAG_TEXT,
                text: firstTag.title,
                textColor: firstTag.textColor,
                backgroundColor: firstTag.backgroundColor,
                borderColor: firstTag.borderColor,
                borderWidth: firstTag.borderColor ? '1rpx' : '0rpx'
            };
        }
    }
    // 3. 优先级第三:headIcon 配置
    if (headIcon) {
        // 3.1 headIcon 有图片(Card组件支持)
        if (headIconImg) {
            return {
                type: CornerMarkType.HEAD_ICON_IMAGE,
                imageUrl: headIconImg,
                backgroundColor: headIconBackgroundColor,
                borderColor: headIconBorderColor,
                borderWidth: headIconBorderColor ? '1rpx' : '0rpx'
            };
        }
        // 3.2 headIcon 有文字
        if (showCornerMark || headIconText) {
            return {
                type: CornerMarkType.HEAD_ICON_TEXT,
                text: showCornerMark || headIconText,
                textColor: headIconTextColor,
                backgroundColor: headIconBackgroundColor,
                borderColor: headIconBorderColor,
                borderWidth: headIconBorderColor ? '1rpx' : '0rpx'
            };
        }
    }
    return {
        type: CornerMarkType.NONE
    };
};
/**
 * 角标组件
 * 优先级：angleImg > posTagList > headIcon
 */
const CornerMark = (props) => {
    const { angleImg, posTagList, headIcon, headIconImg, headIconText, showCornerMark, headIconTextColor, headIconBackgroundColor, headIconBorderColor, isRecallRecommend = false, isHistoryBrowsed = false } = props;
    const cornerMarkInfo = getCornerMarkInfo(angleImg, posTagList, headIcon, headIconImg, headIconText, showCornerMark, headIconTextColor, headIconBackgroundColor, headIconBorderColor, isRecallRecommend, isHistoryBrowsed);
    const isShowImg = [CornerMarkType.HISTORY_BROWSE, CornerMarkType.ANGLE_IMG, CornerMarkType.POS_TAG_IMAGE, CornerMarkType.HEAD_ICON_IMAGE].includes(cornerMarkInfo.type);
    const isShowText = [CornerMarkType.POS_TAG_TEXT, CornerMarkType.HEAD_ICON_TEXT].includes(cornerMarkInfo.type);
    // 不展示角标
    if (cornerMarkInfo.type === CornerMarkType.NONE) {
        return null;
    }
    // 图片类角标(angleImg、posTagImage、headIconImage)
    if (isShowImg && cornerMarkInfo.imageUrl) {
        return <View className="headTagImg">
        
        <LImage source={{
            uri: cornerMarkInfo.imageUrl
        }} height={rpx2px(32)} borderRadius={0} showAnimatioin={false}/>
      </View>;
    }
    // 文字类角标(posTagText、headIconText)
    if (isShowText) {
        return <View style={{
            backgroundColor: cornerMarkInfo.backgroundColor,
            borderColor: cornerMarkInfo.borderColor,
            borderWidth: cornerMarkInfo.borderWidth
        }} className="headTag">
        <Text style={{
            color: cornerMarkInfo.textColor
        }} className="headTagText">
          {cornerMarkInfo.text}
        </Text>
      </View>;
    }
    return null;
};
export default CornerMark;
